import { render } from "./BasicContainer.vue?vue&type=template&id=46494e2e&scoped=true"
import script from "./BasicContainer.vue?vue&type=script&lang=js"
export * from "./BasicContainer.vue?vue&type=script&lang=js"

import "./BasicContainer.vue?vue&type=style&index=0&id=46494e2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46494e2e"]])

export default __exports__